import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ApiLoader from "../common/loader";
import { toast } from "react-toastify";
import { REACT_APP_API_KEY, REACT_APP_API_URL } from "../common/config";
import { routes } from "../routings";

const BootQueue = () => {
  const { token } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!token) {
      setError("Invalid boot queue link");
      setLoading(false);
      return;
    }

    fetchQueue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const fetchQueue = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${REACT_APP_API_URL}boot-queue/${token}`, {
        headers: {
          "api-key": REACT_APP_API_KEY,
        },
      });

      if (response.status === 200 && response.data?.success) {
        setData(response.data.data);
      } else {
        setError(response.data?.message || "Failed to load boot queue");
      }
    } catch (err) {
      if (err.response?.status === 410) {
        setError("This boot queue link has expired");
      } else if (err.response?.status === 404) {
        setError("Invalid boot queue link");
      } else {
        setError(err.response?.data?.message || "Failed to load boot queue");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading && !data) {
    return (
      <section className="main_section" style={{ backgroundColor: "#ffffff", color: "#000000" }}>
        <ApiLoader />
      </section>
    );
  }

  return (
    <section className="main_section" style={{ backgroundColor: "#ffffff", color: "#000000" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            {loading && <ApiLoader />}

            <h3 style={{ marginBottom: "15px" }}>Approved Boots To Install</h3>

            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}

            {!error && data && (
              <>
                {Array.isArray(data.violations) && data.violations.length === 0 ? (
                  <div className="alert alert-success" role="alert">
                    No approved boots are currently pending for you.
                  </div>
                ) : (
                  <div className="panel panel-default">
                    <div className="panel-body">
                      <div style={{ marginBottom: "10px" }}>
                        <button
                          type="button"
                          className="btn btn-default"
                          onClick={() => {
                            toast.info("Refreshing...");
                            fetchQueue();
                          }}
                          disabled={loading}
                        >
                          Refresh
                        </button>
                      </div>

                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th>Violation</th>
                              <th>Plate</th>
                              <th>Boot</th>
                              <th>Property</th>
                              <th>Address</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {data.violations.map((v) => {
                              const bootInstallPath = routes.bootInstall.path.replace(":token", v.boot_install_token);
                              const returnTo = routes.bootQueue.path.replace(":token", token);
                              const href = `${bootInstallPath}?returnTo=${encodeURIComponent(returnTo)}`;

                              return (
                                <tr key={v.violation_id}>
                                  <td>{v.violation_id}</td>
                                  <td>{v.license_plate_number || ""}</td>
                                  <td>{v.boot_serial_number || ""}</td>
                                  <td>{v.property?.name || ""}</td>
                                  <td>
                                    {v.property?.maps_url ? (
                                      <a href={v.property.maps_url} target="_blank" rel="noreferrer">
                                        {v.property.address || ""}
                                      </a>
                                    ) : (
                                      v.property?.address || ""
                                    )}
                                  </td>
                                  <td style={{ whiteSpace: "nowrap" }}>
                                    <Link to={href} className="btn btn-warning">
                                      Add / Confirm Boot Photos
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BootQueue;
